import { createSelector } from '@ngrx/store';
import { IEntitlementsState } from './entitlements.reducer';

// Using direct path instead of createFeatureSelector
export const selectEntitlementsState = (state: any) => state['platform-entitlements'];

export const entitlementsSelectData = createSelector(selectEntitlementsState, (state: IEntitlementsState) => state.data);
